import React from "react";
import "./Contact.css"; // Ajoutez un fichier CSS personnalisé si nécessaire
import ContactForm from "../Contact/ContactForm";

const Contact = () => {
  return (
    <section id="contact" className="container-fluid py-5 bg-warning">
      <div className="container-fluid p-2 p-md-5">
        <div className="row align-items-center">
          {/* Texte à gauche */}
          <div className="col-lg-6 mb-4">
            <h2>Contact Us for Seamless Transfers</h2>
            <p>
              Get in touch for reliable airport transfers in Paris, IDF. We're here to assist you.
            </p>
          </div>

          {/* Formulaire à droite */}
          <div className="col-lg-6">
            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
